import { Link } from "react-router-dom";

// Timeline mark: 3 tracks + playhead + film perforations, teal->purple gradient.
export function EfMark({ size = 30 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="block shrink-0"
      aria-hidden
    >
      <defs>
        <linearGradient id="efmg1" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="var(--accent)" />
          <stop offset="100%" stopColor="var(--accent2)" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="9" fill="url(#efmg1)" />
      <rect x="0.5" y="0.5" width="39" height="19" rx="8.5" fill="rgba(255,255,255,0.07)" />
      <rect x="6" y="9" width="3.5" height="4.5" rx="1" fill="rgba(0,0,0,0.2)" />
      <rect x="6" y="26" width="3.5" height="4.5" rx="1" fill="rgba(0,0,0,0.2)" />
      <rect x="30.5" y="9" width="3.5" height="4.5" rx="1" fill="rgba(0,0,0,0.2)" />
      <rect x="30.5" y="26" width="3.5" height="4.5" rx="1" fill="rgba(0,0,0,0.2)" />
      <rect x="13" y="14" width="18" height="4" rx="2" fill="white" />
      <rect x="13" y="20" width="12" height="3.5" rx="1.75" fill="rgba(255,255,255,0.65)" />
      <rect x="13" y="26" width="15" height="3.5" rx="1.75" fill="rgba(255,255,255,0.8)" />
      <rect x="23" y="12" width="1.5" height="20" rx="0.75" fill="white" opacity="0.95" />
      <polygon points="23,12 24.5,12 23.75,10" fill="white" />
    </svg>
  );
}

const SIZES: Record<"sm" | "md" | "lg", [number, number]> = {
  sm: [24, 14],
  md: [30, 16],
  lg: [38, 21],
};

// Wordmark: "Edits" in accent, "Forge" in text. Links home unless `to={null}`.
export function EfLogo({ size = "md", to = "/" as string | null }: { size?: "sm" | "md" | "lg"; to?: string | null }) {
  const [mark, font] = SIZES[size];
  const inner = (
    <span className="flex shrink-0 items-center gap-[9px]">
      <EfMark size={mark} />
      <span
        className="font-display font-bold leading-none tracking-[-0.03em] text-ef-text"
        style={{ fontSize: font }}
      >
        <span className="text-ef-accent">Edits</span>Forge
      </span>
    </span>
  );
  if (to === null) return inner;
  return (
    <Link to={to} className="flex shrink-0 items-center">
      {inner}
    </Link>
  );
}
